import { pendingOrderIds, localOnline, cloudOnline } from "../state/sync.js";
import { screen, myOrders } from "../state/store.js";

export function StatusBar({ onSettings }: { onSettings: () => void }) {
  return (
    <header class="statusbar">
      <span class="brand">🍺</span>
      <nav class="navtabs">
        <button
          class={screen.value === "order" ? "navtab active" : "navtab"}
          onClick={() => (screen.value = "order")}
        >
          Bestellen
        </button>
        <button
          class={screen.value === "bons" ? "navtab active" : "navtab"}
          onClick={() => (screen.value = "bons")}
        >
          Bestellungen{myOrders.value.length > 0 ? ` (${myOrders.value.length})` : ""}
        </button>
        {/* „Verwaltung" absichtlich NICHT als Tab (Platz auf schmalen Handys) — Zugang über
            das Zahnrad → SettingsModal (🛠️ Verwaltung), gegated auf role==="admin". */}
      </nav>
      <span class="spacer" />
      {pendingOrderIds.value.size > 0 && (
        <span class="pending" title={`${pendingOrderIds.value.size} Bon(s) noch nicht übermittelt`}>
          ↑ {pendingOrderIds.value.size}
        </span>
      )}
      <button
        class={`icon-btn ${localOnline.value || cloudOnline.value ? "net-on" : "net-off"}`}
        onClick={onSettings}
        aria-label="Einstellungen & Status"
        title={
          localOnline.value || cloudOnline.value
            ? "Verbunden – Details unter ⚙︎"
            : "Offline – Bons werden lokal gespeichert"
        }
      >
        ⚙︎
      </button>
    </header>
  );
}
